import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormHelperText, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Form } from 'react-bootstrap';
import parse from 'html-react-parser';

const StyledFormControl = styled(FormControl)({
  '&.shrinkLabel': {
    '& .MuiInputLabel-outlined': {
      transform: 'translate(12px, 12px) scale(1) !important',
      '&.MuiInputLabel-shrink': {
        transform: 'translate(12px, 3px) scale(0.75) !important',
      },
    },
  },
});

export default function TextInput(props) {

  const { errors, labelAbove, label, fullWidth, hiddenLabel, ...textFieldProps } = props;

  return (
    <StyledFormControl fullWidth={(fullWidth !== undefined) ? fullWidth : true} error={!!errors} className={props.isShrinkLabel ? 'shrinkLabel' : ''}>
      {labelAbove &&
        <Form.Label htmlFor={props.id}>{parse(props.label)}</Form.Label>
      }
      <TextField
        hiddenLabel={hiddenLabel ? hiddenLabel : false}
        error={!!errors}
        variant='outlined'
        {...textFieldProps}
        label={labelAbove ? undefined : label}
      />
      <FormHelperText id={`${props.id}-helper-text`} aria-describedby={`${props.id}-helper-text`} className="MuiFormHelperText-contained">{errors && errors.message}</FormHelperText>
    </StyledFormControl>
  )
}

TextInput.propTypes = {
  id: PropTypes.string.isRequired,
  inputRef: PropTypes.func,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  label: PropTypes.string,
  labelAbove: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  errors: PropTypes.object,
  fullWidth: PropTypes.bool,
};
